import classNames from "classnames";
import React from "react";
import { Card, CardBody, type CardProps } from "reactstrap";

interface CardButtonProps extends Omit<CardProps, "tag"> {
  children?: React.ReactNode;
  color?: string;
  className?: string;
  center?: boolean;
}

const CardButton: React.FC<CardButtonProps> = ({ children, color = "primary", className = "", ...props }) => {
  return (
    <Card {...props} tag={"button"} className={classNames(`btn btn-${color} bg-${color} w-100 mx-0`, className)}>
      <CardBody className="text-center w-100 h-100 flex-center">{children}</CardBody>
    </Card>
  );
};

export default CardButton;
